import React, { useState, useEffect } from 'react';
import {
	TextField,
	Button,
	Container,
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ServiceProduct } from 'types/serviceProduct';
import { createPlanField, updatePlanField } from '../../services/api/PlansAPI';

interface ServiceProductFormProps {
	serviceProduct?: ServiceProduct;
	open: boolean;
	handleClose: () => void;
	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
	onSuccess: () => void;
}

interface PlanFieldStructureDevelop {
	label: string;
	type: string;
}

interface Plans {
	fieldDefinitions: PlanFieldStructureDevelop[];
}

const PlanFieldDevelop: React.FC<ServiceProductFormProps> = ({
	serviceProduct,
	open,
	handleClose,
	productNameProvide,
	onSuccess,
}) => {
	const [formData, setFormData] = useState<PlanFieldStructureDevelop[]>([]);
	const [initialLabel, setInitialLabel] = useState<string>('');
	const [loading, setLoading] = useState(false);

	const handleAddPlanField = async () => {
		try {
			if (initialLabel.trim() === '') {
				toast.error('Plan field label cannot be empty.');
				return; // Prevent adding empty fields
			}
			// Logic to add a new plan field
			setFormData([...formData, { label: initialLabel, type: 'String' }]);
			setInitialLabel('');
		} catch (error) {
			console.log(error);
		}
	};

	const handleDeletePlanField = async (index: number) => {
		try {
			// Logic to delete a plan field
			const updatedFormData = [...formData];
			updatedFormData.splice(index, 1);
			setFormData(updatedFormData);
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				if (serviceProduct?.plans && 'fieldDefinitions' in serviceProduct.plans) {
					const plans = serviceProduct.plans as Plans;
					const fieldDefinitions = plans.fieldDefinitions.map((field) => ({
						label: field.label,
						type: field.type,
					}));
					setFormData(fieldDefinitions);
				} else {
					setFormData([]);
				}
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [serviceProduct]);

	const validateForm = () => {
		if (formData.some((field) => field.label.trim() === '')) {
			toast.error('All plan field labels must be filled.');
			return false;
		}
		return true;
	};

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault();
		if (!validateForm()) {
			return;
		}
		try {
			setLoading(true);
			if (serviceProduct?._id) {
				if (Object.keys(serviceProduct?.plans || {}).length > 0) {
					const response = await updatePlanField(
						{ fieldDefinitions: formData as any },
						(serviceProduct?.plans as any)?._id
					);
					if (response.success) {
						toast.success(response.message ? response.message : 'Successfuly update ');
						onSuccess();
						setInitialLabel('');
						setTimeout(() => {
							handleDialogClose();
						}, 3000);
					} else {
						toast.error(
							response.data.message ? response?.data.message : 'Something went wrong'
						);
					}
				} else {
					const data = { serviceId: serviceProduct._id, fieldDefinitions: formData };
					const response = await createPlanField(data);
					if (response.success) {
						toast.success(response.message ? response.message : 'Successfuly update ');
						setInitialLabel('');
						onSuccess();
						setTimeout(() => {
							handleDialogClose();
						}, 3000);
					} else {
						toast.error(
							response.data.message ? response?.data.message : 'Something went wrong'
						);
					}
				}
				// Handle the response as needed
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleDialogClose = () => {
		setFormData([]);
		setInitialLabel('');
		handleClose();
	};

	return (
		<Dialog
			open={open}
			slotProps={{
				paper: {
					sx: {
						minWidth: 300,
						maxWidth: 600,
						width: '90%',
					},
				},
			}}
		>
			<ToastContainer />
			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
				{Object.keys(serviceProduct?.plans || {}).length > 0
					? `Update ${productNameProvide} Plan Field`
					: `Create ${productNameProvide} Plan Field`}
				<IconButton
					aria-label="close"
					onClick={handleDialogClose}
					sx={{ position: 'absolute', right: 8, top: 8 }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Container>
					<Box sx={{ mt: 0 }}>
						<form onSubmit={handleSubmit}>
							{/* <Container> */}
							<TextField
								label={`Price`}
								fullWidth
								margin="normal"
								size="small"
								disabled
							/>
							<TextField
								label={`Internet Speed`}
								fullWidth
								margin="normal"
								size="small"
								disabled
							/>
							<TextField
								label={`Offers/Plan Name`}
								fullWidth
								margin="normal"
								size="small"
								disabled
							/>
							<TextField
								label={`Validity`}
								fullWidth
								margin="normal"
								size="small"
								disabled
							/>

							{formData.map((value, index) => (
								<Typography
									key={index}
									sx={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<TextField
										label={`Plan Field Label ${index + 1}`}
										name="label"
										value={value.label}
										fullWidth
										margin="normal"
										size="small"
										onChange={(e) => {
											const updatedFormData = [...formData];
											updatedFormData[index].label = e.target.value;
											setFormData(updatedFormData);
										}}
									/>
									<Typography>
										<IconButton
											aria-label="delete"
											onClick={() => handleDeletePlanField(index)}
										>
											<DeleteIcon />
										</IconButton>
									</Typography>
								</Typography>
							))}
							{/* </Container> */}
							{/* <Typography sx={{ display: 'flex', justifyContent: 'space-between' }}>
								<TextField
									label="Plan Field Label"
									name="label"
									value={initialLabel}
									fullWidth
									margin="normal"
									size="small"
									onChange={(e) => setInitialLabel(e.target.value)}
								/>
								<IconButton
									aria-label="add"
									onClick={handleAddPlanField}
									disabled={initialLabel.trim() === ''}
								>
									<AddCircleOutlineIcon />
								</IconButton>
							</Typography> */}

							<Typography
								sx={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								<TextField
									label="Plan Field Label"
									name="label"
									value={initialLabel}
									fullWidth
									margin="normal"
									size="small"
									onChange={(e) => setInitialLabel(e.target.value)}
								/>
								<IconButton
									aria-label="add"
									onClick={handleAddPlanField}
									disabled={initialLabel.trim() === ''}
									sx={{
										borderRadius: '50%', // make button circular
										width: 40,
										height: 40,
										padding: 0,
										'&:hover': {
											borderRadius: '50%',
										},
									}}
								>
									<AddCircleOutlineIcon />
								</IconButton>
							</Typography>
							<Typography color="gray" variant="caption">
								<strong>NOTE:-</strong>
								<br />
								You can add multiple plan fields. However,{' '}
								<strong>
									Price, Internet Speed, Offers/Plan Name, and Validity
								</strong>{' '}
								are already included in the plan creation form by default.
								<strong>Please do not add these fields again</strong>, as doing so
								will result in them being displayed twice in the final plan
							</Typography>
							<DialogActions>
								<Button
									onClick={handleDialogClose}
									color="secondary"
									variant="outlined"
								>
									Cancel
								</Button>

								<Button
									type="submit"
									variant="contained"
									color="primary"
									disabled={
										loading ||
										formData.length === 0 ||
										formData.some((field) => field.label.trim() === '')
									}
									loading={loading}
									loadingIndicator="Sending..."
								>
									Submit
								</Button>
							</DialogActions>
						</form>
					</Box>
				</Container>
			</DialogContent>
		</Dialog>
	);
};

export default PlanFieldDevelop;
